/**
 * Build the initial composer text for replying to a league message.
 *
 * The original message is turned into a markdown blockquote: every line is
 * prefixed with `>` so multi-line messages (and the blank lines between
 * paragraphs) stay inside the same quote when rendered. Two trailing newlines
 * leave the cursor on an empty line below the quote, ready for the reply.
 */
export const buildReplyQuote = (text: string): string => {
  // Normalise CRLF / CR line breaks so splitting on "\n" handles every case.
  const normalized = text.replace(/\r\n?/g, '\n');

  const quoted = normalized
    .split('\n')
    .map((line) => (line.length === 0 ? '>' : `> ${line}`))
    .join('\n');

  return `${quoted}\n\n`;
};
